export type FaqItem = {
    q: string;
    a: string;
};

export const FAQ: FaqItem[] = [
    {
        q: "What tokens are currently supported?",
        a: "We support all major tokens across popular blockchain networks including Bitcoin, Ethereum, USDT, USDC, BNB, Litecoin, Monero, Gram and more. New tokens are added regularly based on market demand.",
    },
    {
        q: "Can my customers pay by card?",
        a: "Yes, customers in the US and the EU can. On the checkout they tap “Pay by card”: our partner Stripe processes the card and buys the exact invoice amount in USDC, which arrives on your invoice like any other crypto payment. Stripe handles card fraud and disputes, and the card and network fees are paid by the customer. The button appears on every invoice that accepts USDC, except permanent-address ones.",
    },
    {
        q: "Can I avoid crypto volatility?",
        a: "Yes. Auto-conversion automatically swaps incoming BTC, ETH and other coins into USDT or USDC at the moment of payment, so your merchant balance is held in stablecoins. The conversion fee is included in the published rates.",
    },
    {
        q: "Where are my funds held? Is PawPayments custodial?",
        a: "PawPayments is a custodial processor. Incoming payments are received on operational wallets we control and credited to your merchant balance, from which you can withdraw to any external wallet at any time. There are no minimums or holds for verified merchants.",
    },
    {
        q: "How long does merchant setup take?",
        a: "Merchant setup takes about 5 minutes. You register, create a merchant, configure the tokens and payment settings you need, and you're ready to accept crypto payments. KYB verification typically completes in minutes to a few hours.",
    },
    {
        q: "How do I integrate PawPayments?",
        a: "We provide a hosted invoice page (no code required), a REST API and webhook events documented at docs.pawpayments.com. Most stores go live with a single API key and one webhook endpoint.",
    },
    {
        q: "What are the commission rates?",
        a: "Our standard rate is 1.8% for small companies. Medium businesses get 1.2%, and high-volume projects can negotiate custom terms starting from 0.5%. Contact us to discuss the best plan for your needs.",
    },
    {
        q: "Is there a minimum volume to start?",
        a: "No. There is no minimum volume to register a merchant or accept payments. Custom rates from 0.5% become available once monthly volume reaches the relevant tier.",
    },
    {
        q: "How do withdrawals work?",
        a: "Withdrawals are instant and processed without delays or holds. You can withdraw your funds to any external wallet at any time directly from your merchant dashboard.",
    },
];
